var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"new-comics-text"},[_vm._v("Latest Releases:")]),_c('div',{staticClass:"new-comics-list"},_vm._l((_vm.comics),function(comic){return _c('comic-card-marvel-api',{key:comic.upc,attrs:{"comic":comic}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }